import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private http: HttpClient) {}

  getAllProjects(): Observable<any> {
    return this.http.get(`${environment.backend.sso}/v1/projects/all`);
  }

  toggleFavorite(clientId: string, pinned: boolean): Observable<any> {
    return this.http.post(
      `${environment.backend.sso}/v1/projects/${clientId}/favorite`,
      {},
      { params: { pinned: String(pinned) } }
    );
  }

  getMyAccounts(): Observable<any> {
    return this.http.get(`${environment.backend.sso}/v1/user/accounts`);
  }

  getLastLogin(): Observable<any> {
    return this.http.get(`${environment.backend.sso}/v1/user/last-login`);
  }

  getProjectGroups(): Observable<any> {
    return this.http.get(`${environment.backend.sso}/v1/projects/groups`);
  }
}
